import AbstractApiService from "./AbstractApiService";

export default class GifService extends AbstractApiService {
    get = (search: string): Promise<any> => {
        return this.call('GET', `/gifs?search=${search}`);
    };
}
